// src/api/users.api.ts
import { BaseResponse } from '@app/entities/BaseResponse';
import { IList } from '@app/entities/IListResponse';
import { apiRequest } from './apiUtils';

/** ===== Types (kept as you defined) ===== */
export interface UserRequest {
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  mobilePhoneNumber: string;
  isActive: boolean;
}

export interface UpdateUser {
  id: string;
  username: string;

  firstName: string;
  lastName: string;
  email: string;
  mobilePhoneNumber: string;
  isActive: boolean;
}

export interface UpdateUserPassword {
  id: string;
  password: string;
  ipAddress: string;
}

export interface DeleteUser {
  deletedByIpAddress: string;
  deletedByUserId: number;
}

export interface UserResponse {
  id: string;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  mobilePhoneNumber: string;
  active: boolean;
}

export interface UserByIdResponse {
  id: string;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  mobilePhoneNumber: string;
  isActive: boolean;
}

/** ===== Base ===== */
const BASE_URL = 'users';

/** ===== Endpoints (apiRequest style) ===== */

export const getUserByPaging = (
  pageSize: number,
  pageNumber: number,
  username: string
): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}`, {
    params: { pageSize, pageNumber, username },
  });



export const getUserById = (
  userId: string
): Promise<BaseResponse<UserByIdResponse>> =>
  apiRequest<BaseResponse<UserByIdResponse>>('GET', `${BASE_URL}/${userId}`);

export const getUsers = (): Promise<BaseResponse<UserResponse[]>> =>
  apiRequest<BaseResponse<UserResponse[]>>('GET', `${BASE_URL}`);

export const doAddUsers = (
  payload: UserRequest
): Promise<BaseResponse<UserResponse>> =>
  apiRequest<BaseResponse<UserResponse>>('POST', `${BASE_URL}/createUser`, payload);

export const doUpdateUsers = (
  userId: string,
  payload: UpdateUser
): Promise<BaseResponse<UserResponse>> =>
  apiRequest<BaseResponse<UserResponse>>('PUT', `${BASE_URL}/${userId}`, payload);

export const updateUsername = (
  userId: string,
  payload: { username: string }
): Promise<BaseResponse<boolean>> =>
  apiRequest<BaseResponse<boolean>>(
    'PUT',
    `${BASE_URL}/${userId}/update-username`,
    payload
  );

export const doDeleteUser = (
  userId: string,
  payload: DeleteUser
): Promise<BaseResponse<UserResponse>> =>
  apiRequest<BaseResponse<UserResponse>>(
    'PUT',
    `${BASE_URL}/${userId}/soft-delete`,
    payload
  );

export const doResetPassword = (
  userId: string
): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>(
    'PUT',
    `${BASE_URL}/${userId}/reset-password`
  );

export const doChangePassword = (
  currentPassword: string,
  newPassword: string,
  confirmPassword: string
): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>(
    'PUT',
    `${BASE_URL}/info/change-password`,
    { currentPassword, newPassword, confirmNewPassword: confirmPassword }
  );


export const updateMobilePhoneNumber = (
  userId: string,
  payload: { mobilePhoneNumber: string }
): Promise<BaseResponse<boolean>> =>
  apiRequest<BaseResponse<boolean>>(
    'PUT',
    `${BASE_URL}/${userId}/update-mobilePhoneNumber`,
    payload
  );

export const updateEmail = (
  userId: string,
  payload: { email: string }
): Promise<BaseResponse<boolean>> =>
  apiRequest<BaseResponse<boolean>>(
    'PUT',
    `${BASE_URL}/${userId}/update-email`,
    payload
  );